import React from "react";
import exportFromJSON from "export-from-json";

const DownloadSample = ({ canDownload }) => {
  const data = [
    {
      callId: "XXXXX",
      callDuration: "51.01",
      created_date: "September 2, 2025, 6:49 PM",
      campaign: "agent_creation_voice_test",
      call_status: "SUCCESS/NOT_CONNECTED",
      customer_number: "91XXXXXXXXXX",
      Name: "John Doe",
      Interest: "YES/NO",
      Position_Applied_For: "WFH/WFO/NA",
      English_and_Hindi: "YES/NO/NA",
      Package_Confirmation: "XXXXX/not_mentioned/NA",
      Broadband_and_System_availability: "YES/NO/NA",
      wfo_preferred_location: "Amritsar/not_mentioned",
      qualification_extraction: "Graduate/NA",
      user_call_status: "Success",
      wfh_preferred_location:"vadodara/NA"
    },
  ];

  const handleClickSample = () => {
    exportFromJSON({ data, fileName: "SAMPLE_VOICE_BOT", exportType: "csv" });
  };

  return (
    <div className="w-100 d-flex justify-content-between align-items-center">
      <h6 className="mb-0">Upload Voice Bot</h6>
      {canDownload && (
        <button className="btn-sm btn-primary px-3" onClick={handleClickSample}>
          Download Sample
        </button>
      )}
    </div>
  );
};

export default DownloadSample;
